export interface ShopItem {
    id: string;
    name: string;
    type: 'potion' | 'uprgrade' | 'scroll';
    cost: number;
    description: string;
    icon?: string; // Emoji for now, or asset path
}

export const shopItems: ShopItem[] = [
    {
        id: 'health_potion',
        name: 'Health Potion',
        type: 'potion',
        cost: 50,
        description: 'Restores 50 HP.',
        icon: '❤️'
    },
    {
        id: 'speed_potion',
        name: 'Speed Potion',
        type: 'potion',
        cost: 100,
        description: 'Increases movement speed for 30s.',
        icon: '⚡'
    },
    {
        id: 'magic_scroll',
        name: 'Fire Scroll',
        type: 'scroll',
        cost: 200,
        description: 'A scroll containing ancient fire magic.',
        icon: '📜'
    },
    {
        id: 'iron_sword',
        name: 'Iron Sword',
        type: 'uprgrade',
        cost: 500,
        description: 'A sturdy iron sword. Increases damage.',
        icon: '⚔️'
    }
];
